import { createSelector } from '@ngrx/store';

import { selectRateFeatureState, State } from '@ruby/modules/rate-inquiry/store';
import * as fromRateCore from '@ruby/modules/rate-inquiry/store/reducers/rate-core.reducer';
import * as fromRateForm from '@ruby/modules/rate-inquiry/store/reducers/rate-form.reducer';
import { selectCoreState } from '@ruby/modules/rate-inquiry/store/selectors/rate-core.selectors';

export const selectFormState = createSelector(
  selectRateFeatureState,
  (rateState: State) => (rateState[fromRateForm.featureKey])
);

export const selectFormWithCoreCustomerState = createSelector(
  selectCoreState,
  selectFormState,
  (coreState: fromRateCore.State, formState: fromRateForm.State) => ({
    core: coreState,
    form: formState
  })
);
